
var Model = require("../types/Model.js");
var validator = require("is-my-json-valid");
var jsonpatch = require("fast-json-patch");
var xtend = require("xtend");
var prop = require("prop");
var makeProp = require("make-prop");
var deepMerge = require("deepmerge");
var dotty = require("dotty");
var debounce = require("debounce");

module.exports = Model({
	name: "managedcareplansectioneditor",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_schema: null,
	_careplan: null,

	reset: reset,
});

function init() {
	this._schema = null;
	this.reset();
}

function uninit() {
	this._schema = null;
	this._careplan = null;
}

function listeners() {
	return {
		"careplanschema:updated": handle_careplan_schema_updated,
		"managedcareplanoverlay:updated": handle_careplan_section_updated,
	};
}

function triggers() {
	return {
		start: start,
		validate: validate,
		finish: debounce(finish, 500),
		reset: reset,
		add: add_item,
		remove: remove_item,
	};
}

function start(data) {
	var section = data.section;
	var original = this._careplan;
	var who = data.who;
	var group = data.group;

	this._who = who;
	this._group = group;

	var cloned = JSON.parse(JSON.stringify(original));

	this.push({
		schema: this._schema.data.properties[section],
		original: cloned,
		editing: {},
		errors: null,
		section: section
	});

	this.dispatch("editing", {
		section: section,
	});
}

function validate(data) {
	var schema = this._schema.data.properties[this.data.section];
	var validateFN = validator(schema, {
		greedy: true
	});

	var isValid  = validateFN(data);

	if(isValid){
		if(this.data.errors)
			this.extend({
				errors: null
			});
	} else {
		this.extend({
			errors: validateFN.errors
		});
	}
}

function finish(data) {
	var who = this._who;
	var section = this.data.section;
	var existing = this._careplan;
	var formatted = arrayIfy(data);

	var cleaned = xtend(existing);

	delete cleaned.section;
	delete cleaned.SectionUpdateAudit;

	if(this.data.errors) return;

	var changes = jsonpatch.compare(cleaned, formatted);

	var validChanges = changes.filter(function(change){
		var path = change.path;
		if(path.indexOf("SectionUpdateAudit") !== -1) return false;
		if(path === "/section") return false;
		return !path.match(/\/(?:Code(?:Set)?|Type|Comment)$/);
	}).filter(function(change){
		var op = change.op;
		if(op !== "remove") return true;
		var path = change.path;
		var dotPath = path.replace(/\//g, ".").slice(1);
		var value = prop(dotPath)(existing);
		return (value !== "");
	}).map(function(change){
		var op = change.op;
		if(op === "replace" && change.value === null){
			change.op = "remove";
			delete change.value;
			return change;
		}
		if(op !== "add") return change;
		var path = change.path;

		var matches = path.match(/^(.*\/)(\d+)$/);
		if(!matches) return change;
		var newPath = matches[1] + "-";

		return xtend(change, {
			path: newPath
		});
	});

	if(!validChanges)
		return;

	const group = this._group;

	this.emit("save:trigger:start");
	this.api.manage.careplan[section.toLowerCase()]
		.changes.proposed.add(who, validChanges, group)
		.then(handleFinished.bind(this))
		.catch(console.error.bind(console))
		.then(finishSave.bind(this));
}

function arrayIfy(data) {
	if(typeof data !== "object")
		return data;

	var keys = Object.keys(data);

	if(!keys.length) return data;

	var isObject = keys.some(isNaN);

	if(isObject) return keys.reduce(function(result, key){
		result[key] = arrayIfy(data[key]);
		return result;
	}, {});

	var converted = [];
	var total = keys.length;
	var index = 0;
	for(index; index < total; index++)
		converted.push(data[index]);

	return converted;
}


function reset() {
	this.push({
		original: {},
		editing: {},
		errors: null,
		section: ""
	});
}

function add_item(data) {
	var schema = this._schema.data.properties[this.data.section].properties;
	var path = data.schema;
	var newData = data.data;
	var definition = prop(path)(schema);
	var itemType = definition.items.type;
	var current = prop(newData)(this._careplan) || [];
	var newItem = null;
	if (itemType === "object") {
		newItem = {};
	} else {
		newItem = "";
	}
	var newArray = current.concat(newItem);
	var updateObject = makeProp(newData)(newArray);
	var mergedCareplan = deepMerge(this.data.original, updateObject, {
		clone: true
	});

	this.extend({
		original: mergedCareplan,
	});
}

function remove_item (data) {
	var path = data.path;
	var index = parseInt(data.index, 10);
	var current = prop(path)(this.data.original);

	var originalObject = this.data.original;

	var cloned = JSON.parse(JSON.stringify(originalObject));

	var newArray = current.filter(function(item, itemIndex){
		return itemIndex !== index;
	});

	dotty.put(cloned, path, newArray);

	this.extend({
		original: cloned,
	});
}


function handleFinished(data) {
	this.dispatch("editing:finished", data);
}

function finishSave() {
	this.emit("save:trigger:finish");
	this.emit("toast:trigger:show", {
		content: "careplanedit.Saved",
	});
}

function handle_careplan_schema_updated(schema) {
	this._schema = schema;
}

function handle_careplan_section_updated(careplan) {
	this._careplan = careplan;
}
